import { useState, useEffect, useRef } from "react";
import { Box, Typography, Button, CardMedia, Divider } from "@mui/material";
import { rsAddress, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import { toMoney } from "../../util/Utils";
import { useSearchParams } from "react-router-dom";
import { UseAdvContract } from "./UseAdvContract";

export default function AdvFactorPrint(props) {
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [data, setData] = useState();
  const componentRef = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const { getAdvContractfactorByID } = UseAdvContract();

  useEffect(() => {
    setMsAddress(true);
    setProgress(true);
    if (searchParams.get("contractID")) {
      setProgress(true);
      getAdvContractfactorByID(searchParams.get("contractID"), (advs) => {
        setProgress(false);
        setData({
          title1: advs.staticsData.find((m) => m.enTitle == "title1")?.faTitle,
          logo: advs.staticsData.find((m) => m.enTitle == "logo")?.value,
          subject: {
            title: advs.staticsData.find((m) => m.enTitle == "subject")
              ?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "subject")?.value,
          },
          phoneOrg: {
            title: advs.staticsData.find((m) => m.enTitle == "phone")?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "phone")?.value,
          },
          comment1: {
            title: advs.staticsData.find((m) => m.enTitle == "comment1")
              ?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "comment1")?.value,
          },
          comment2: {
            title: advs.staticsData.find((m) => m.enTitle == "comment2")
              ?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "comment2")?.value,
          },
          comment3: {
            title: advs.staticsData.find((m) => m.enTitle == "comment3")
              ?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "comment3")?.value,
          },
          licence: {
            title: advs.staticsData.find((m) => m.enTitle == "licence")
              ?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "licence")?.value,
          },
          nationalcode: {
            title: advs.staticsData.find((m) => m.enTitle == "nationalcode")
              ?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "nationalcode")
              ?.value,
          },
          addressOrg: {
            title: advs.staticsData.find((m) => m.enTitle == "address")
              ?.faTitle,
            value: advs.staticsData.find((m) => m.enTitle == "address")?.value,
          },
          id: advs.id,
          customer: advs.customer,
          discount: advs.discount,
          totalCost: advs.totalCost,
          cost: advs.cost,
          vat: advs.vat,
          customerId: advs.customerId,
          factorDate: advs.shamsiFactorDate,
          phone: advs.phone,
          items: advs.items,
          registerNO: advs.registerNO,
          nationalCode: advs.nationalCode,
          economicCode: advs.economicCode,
          address: advs.address,
          postalCode: advs.postalCode,
          isOfficial: advs.isOfficial,
        });
      });
    }
  }, [searchParams]);

  return (
    data && (
      <>
        <ReactToPrint
          copyStyles={true}
          trigger={() => (
            <Button
              sx={{ m: 2, width: "100px" }}
              aria-label="Print Licensee profile"
              aria-haspopup="false"
              color="secondary"
              variant="contained"
            >
              چاپ
            </Button>
          )}
          content={() => componentRef.current}
        />
        <Box
          ref={componentRef}
          sx={{
            width: "20cm",
            direction: "ltr",
            mx: "auto",
          }}
        >
          <Box sx={{ height: "3cm" }}></Box>

          <Box
            sx={{
              border: ".3px solid black",
              m: 2,
            }}
          >
            <Box
              sx={{
                borderBottom: ".3px solid black",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                // p: 2,
              }}
            >
              <Typography
                sx={{
                  p: 1,
                  width: "75%",
                }}
                variant="subtitle2"
              >
                {data.title1 ? data.title1 : "-"}
              </Typography>
              <Box
                sx={{
                  width: "25%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderLeft: ".3px solid black",
                  p: 1,
                }}
              >
                <CardMedia
                  sx={{ width: "100px" }}
                  component="img"
                  alt="green iguana"
                  image={data.logo ? data.logo : ""}
                />
              </Box>
            </Box>
            <Box
              sx={{
                borderBottom: ".3px solid black",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "75%",
                  px: 1,
                  py: 0.5,
                }}
              >
                <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                  {data.licence.title ? data.licence.title : "-"}
                  {data.licence.value ? data.licence.value : "-"}
                </Typography>

                <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                  {data.addressOrg.title ? data.addressOrg.title : "-"}
                  {data.addressOrg.value ? data.addressOrg.value : "-"}
                </Typography>
                <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                  {data.phoneOrg.title ? data.phoneOrg.title : "-"}
                  {data.phoneOrg.value ? data.phoneOrg.value : "-"}
                </Typography>
                {data.isOfficial ? (
                  <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                    {data.nationalcode.title ? data.nationalcode.title : "-"}
                    {data.nationalcode.value ? data.nationalcode.value : "-"}
                  </Typography>
                ) : (
                  ""
                )}
              </Box>
              <Box
                sx={{
                  width: "25%",
                  display: "flex",
                  borderLeft: ".3px solid black",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    borderBottom: ".3px solid black",
                    py: 1,
                    textAlign: "center",
                  }}
                  variant="subtitle2"
                >
                  تاریخ : {data.factorDate}
                </Typography>
                <Typography
                  sx={{ textAlign: "center", fontSize: "12px", py: 1 }}
                  variant="subtitle2"
                >
                  شماره فاکتور : {data.id}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                borderBottom: ".3px solid black",
                display: "flex",
                flexDirection: "column",
                // justifyContent: "space-between",
                width: "100%",
                py: 0.5,
                px: 1,
              }}
            >
              <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                طرف قرارداد : {data.customer}
              </Typography>
              {data.isOfficial && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                    شماره ثبت : {data.registerNO ? data.registerNO : "-"}
                  </Typography>
                  <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                    شناسه ملی : {data.nationalCode ? data.nationalCode : "-"}
                  </Typography>
                  <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                    کد اقتصادی : {data.economicCode ? data.economicCode : "-"}
                  </Typography>
                </Box>
              )}

              {data.isOfficial && (
                <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                  نشانی : {data.address ? data.address : "-"}
                </Typography>
              )}
              {data.isOfficial && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                    تلفن : {data.phone ? data.phone : "-"}
                  </Typography>
                  <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                    کد پستی : {data.postalCode ? data.postalCode : "-"}
                  </Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                borderBottom: ".3px solid black",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                py: 0.5,
                px: 1,
              }}
            >
              <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
                {data.subject.title ? data.subject.title : "-"}
                {data.subject.value ? data.subject.value : "-"}
              </Typography>
            </Box>
            <Box>
              <Box
                sx={{
                  borderBottom: ".3px solid black",
                  backgroundColor: "#EAF2DD",
                }}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={1}
              >
                <Box gridColumn="span 1">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      py: 1,
                      fontSize: "13px",
                    }}
                  >
                    ردیف
                  </Typography>
                </Box>
                <Box
                  gridColumn="span 5"
                  sx={{ borderLeft: ".3px solid black" }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "13px",

                      py: 1,
                    }}
                  >
                    عنوان
                  </Typography>
                </Box>

                <Box
                  sx={{ borderLeft: ".3px solid black" }}
                  gridColumn="span 2"
                >
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "13px",
                      py: 1,
                    }}
                  >
                    مدت زمان
                  </Typography>
                </Box>
                <Box
                  sx={{ borderLeft: ".3px solid black" }}
                  gridColumn="span 1"
                >
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "13px",

                      py: 1,
                    }}
                  >
                    تعداد
                  </Typography>
                </Box>
                <Box
                  sx={{ borderLeft: ".3px solid black" }}
                  gridColumn="span 3"
                >
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "13px",

                      py: 1,
                    }}
                  >
                    قیمت (ریال)
                  </Typography>
                </Box>
              </Box>
              {data &&
                data.items.map((model, i) => {
                  return (
                    <Box
                      key={i}
                      sx={{
                        borderBottom: ".3px solid black",
                      }}
                      display="grid"
                      gridTemplateColumns="repeat(12, 1fr)"
                      gap={1}
                    >
                      <Box gridColumn="span 1">
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "13px",
                            py: 1,
                          }}
                        >
                          {model.row}
                        </Typography>
                      </Box>

                      <Box
                        sx={{ borderLeft: ".3px solid black" }}
                        gridColumn="span 5"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "13px",
                            py: 1,
                          }}
                        >
                          {model.title}
                        </Typography>
                      </Box>

                      <Box
                        sx={{ borderLeft: ".3px solid black" }}
                        gridColumn="span 2"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "13px",
                            py: 1,
                          }}
                        >
                          {model.time ? model.time : 0}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ borderLeft: ".3px solid black" }}
                        gridColumn="span 1"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "13px",
                            py: 1,
                          }}
                        >
                          {model.counter ? toMoney(model.counter) : 0}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ borderLeft: ".3px solid black" }}
                        gridColumn="span 3"
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "13px",
                            py: 1,
                          }}
                        >
                          {model.cost ? toMoney(model.cost) : 0}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              <Box
                sx={{
                  borderBottom: ".3px solid black",
                }}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={1}
              >
                <Box gridColumn="span 9">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "end",
                      p: 1,
                      fontSize: "13px",
                    }}
                  >
                    مجموع
                  </Typography>
                </Box>
                <Box gridColumn="span 3">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      p: 1,
                      borderLeft: ".3px solid black",
                      fontSize: "13px",
                    }}
                  >
                    {data.cost ? toMoney(data.cost) : 0}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  borderBottom: ".3px solid black",
                }}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={1}
              >
                <Box gridColumn="span 9">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "end",
                      p: 1,
                      fontSize: "13px",
                    }}
                  >
                    مالیات بر ارزش افزوده
                  </Typography>
                </Box>
                <Box gridColumn="span 3">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      p: 1,
                      borderLeft: ".3px solid black",
                      fontSize: "13px",
                    }}
                  >
                    {data.vat ? toMoney(data.vat) : 0}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  borderBottom: ".3px solid black",
                }}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={1}
              >
                <Box gridColumn="span 9">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "end",
                      p: 1,
                      fontSize: "13px",
                    }}
                  >
                    تخفیف
                  </Typography>
                </Box>
                <Box gridColumn="span 3">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      p: 1,
                      borderLeft: ".3px solid black",
                      fontSize: "13px",
                    }}
                  >
                    {data.discount ? toMoney(data.discount) : 0}
                  </Typography>
                </Box>
              </Box>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                <Box gridColumn="span 9">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "end",
                      p: 1,
                      fontSize: "13px",
                    }}
                  >
                    مبلغ قابل پرداخت
                  </Typography>
                </Box>
                <Box gridColumn="span 3">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      p: 1,
                      borderLeft: ".3px solid black",
                      fontSize: "13px",
                    }}
                  >
                    {data.totalCost ? toMoney(data.totalCost) : 0}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              border: ".3px solid black",
              p: 1,
              m: 2,
            }}
          >
            <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
              {data.comment1.title ? data.comment1.title : "-"}
              {data.comment1.value ? data.comment1.value : "-"}
            </Typography>
            <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
              {data.comment2.title ? data.comment2.title : "-"}
              {data.comment2.value ? data.comment2.value : "-"}
            </Typography>
            <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
              {data.comment3.title ? data.comment3.title : "-"}
              {data.comment3.value ? data.comment3.value : "-"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              p: 1,
              m: 2,
              width: "70%",
            }}
          >
            <Typography sx={{ fontSize: "12px" }} variant="subtitle2">
              مهر و امضا
            </Typography>
          </Box>
        </Box>
      </>
    )
  );
}
